import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import {
  CommonIconProps,
  IconSize,
  LogoIconProps
} from 'shared/entities/components/Icon';

const MAXIcon: React.FC<LogoIconProps> = ({ color, ...rest }) => {
  return (
    <BaseIcon
      iconSize={IconSize.XL}
      svgProps={{ viewBox: '0 0 32 32' }}
      {...rest}
    >
      <g clipPath="url(#clip0_59118_117)">
        <path
          d="M24.0102 0H7.98979C3.57715 0 0 3.57715 0 7.98979V24.0102C0 28.4228 3.57715 32 7.98979 32H24.0102C28.4228 32 32 28.4228 32 24.0102V7.98979C32 3.57715 28.4228 0 24.0102 0Z"
          fill={
            color === 'original'
              ? 'url(#paint0_linear_59118_117)'
              : 'currentColor'
          }
        />
        <path
          d="M24.0102 0H7.98979C3.57715 0 0 3.57715 0 7.98979V24.0102C0 28.4228 3.57715 32 7.98979 32H24.0102C28.4228 32 32 28.4228 32 24.0102V7.98979C32 3.57715 28.4228 0 24.0102 0Z"
          fill={
            color === 'original'
              ? 'url(#paint1_radial_59118_117)'
              : 'currentColor'
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2628 28.1065C13.8625 28.1065 12.7471 27.7561 10.8083 26.3545C9.58187 27.9313 5.69832 29.1635 5.52894 27.0553C5.52894 25.4727 5.17854 24.1353 4.78142 22.6753C4.3084 20.8766 3.77112 18.8735 3.77112 15.9711C3.77112 9.03905 9.45925 3.82397 16.1985 3.82397C22.9437 3.82397 28.2288 9.29601 28.2288 16.0353C28.2515 22.6704 22.8978 28.0711 16.2628 28.1065ZM16.3621 9.81575C13.08 9.64641 10.5221 11.9182 9.95563 15.4805C9.48843 18.4297 10.3177 22.0213 11.0243 22.2081C11.3631 22.2899 12.2157 21.6008 12.7471 21.0694C13.6259 21.6764 14.6492 22.041 15.7138 22.1264C19.1146 22.29 22.0204 19.701 22.2487 16.304C22.3816 12.8997 19.7633 10.0164 16.3621 9.82161V9.81575Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_59118_117"
          x1="3.7711"
          y1="24.3372"
          x2="32"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#44CCFF" />
          <stop offset="0.662" stopColor="#5533EE" />
          <stop offset="1" stopColor="#9933DD" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_59118_117"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-0.761305 -14.0539) rotate(51.356) scale(38.8325 16)"
        >
          <stop stopColor="#0000FF" />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_59118_117">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

export const MAXOriginalIcon: React.FC<CommonIconProps> = (props) => {
  return <MAXIcon color="original" {...props} />;
};

export const MAXTransparentIcon: React.FC<CommonIconProps> = (props) => {
  return <MAXIcon color="transparent" {...props} />;
};
